angular
  .module('http.gdprrequest', [])
  /**
   * Service used to access all calls to the gdpr request rest service.
   */
  .factory('httpGdprRequest', function ($http) {
    /**
     * Get pre signed post request.
     *
     * @param {Number} uploadTimestamp - The timestamp to mark the s3 key with.
     * @returns {Promise<String>} A promise that when resolved will include an object.
     */
    const getPreSignedPostUrl = function (uploadTimestamp) {
      return $http({
        method: 'GET',
        url: 'api/gdpr/upload-csv-url',
        params: { uploadTimestamp: uploadTimestamp }
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Upload the file to s3 using pre signed url.
     *
     * @param {String} url - The url to post to
     * @param {File} file - The file to upload.
     * @returns {Promise} - A promise that when resolved will include an object indicating a success.
     */
    const uploadFileToUrl = function (url, file) {
      return $http({
        method: 'PUT',
        headers: { 'Content-Type': 'text/csv' },
        url: url,
        data: file
      }).then(function (res) {
        return res.data;
      });
    };

    /**
     * Get batch details
     * @param params
     * @returns {*}
     */
    const getDetails = function (params) {
      return $http({
        method: 'GET',
        url: 'api/gdpr/details',
        params: params
      }).then(function (res) {
        return res.data;
      });
    };

    return {
      getPreSignedPostUrl,
      uploadFileToUrl,
      getDetails
    };
  });
